require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./yarrabend-residents-app.json") })
        }
      }, "path---yarrabend-residents-app");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---yarrabend-residents-app!./.cache/json/yarrabend-residents-app.json
// module id = 904
// module chunks = 231608221292675